document.addEventListener("DOMContentLoaded", function () {
  const preorderButtons = document.querySelectorAll('[data-preorder="true"]');

  preorderButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault(); // Prevent normal add-to-cart action

      // OPTIONAL: you can pass product ID or title as a query param
      const productTitle = document.querySelector("h1.product__title")?.textContent?.trim();
      const productHandle = window.location.pathname.split('/').pop();

      // Redirect to your pre-order form URL
      const redirectUrl = `/pages/pre-order-form?product=${encodeURIComponent(productTitle || productHandle)}`;
      window.location.href = redirectUrl;
    });
  });
});